import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ClipboardCheck } from 'lucide-react';
import StudentSnapshot from '@/components/StudentSnapshot';
import { scoreToWidaLevel } from '@/utils/proficiencyHelpers';

const RecentResultsTab = ({ recentResults }) => {
  return (
    <div className="border-2 border-gray-200">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center">
        <h3 className="font-bold">Recent Assessment Results</h3>
        <Link to="/results">
          <Button variant="outline" size="sm" className="btn-sharp">
            View All
          </Button>
        </Link>
      </div>
      
      {recentResults.length === 0 ? (
        <div className="p-12 text-center text-gray-500">
          <ClipboardCheck className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p>No completed assessments yet</p>
        </div>
      ) : (
        <div className="divide-y divide-gray-100">
          {recentResults.map(result => (
            <Link
              key={result.id}
              to={`/results/${result.exam_session_id}`}
              className="flex items-center justify-between p-4 hover:bg-gray-50"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 border border-gray-300 flex items-center justify-center font-bold">
                  {result.overall_score}
                </div>
                <div>
                  <StudentSnapshot
                    name={result.student_name}
                    levels={{
                      listening: scoreToWidaLevel(result.modality_scores?.listening),
                      speaking: scoreToWidaLevel(result.modality_scores?.speaking),
                      reading: scoreToWidaLevel(result.modality_scores?.reading),
                      writing: scoreToWidaLevel(result.modality_scores?.writing),
                    }}
                    compositeLevel={result.wida_level || scoreToWidaLevel(result.overall_score)}
                  >
                    <span className="font-semibold hover:text-[#002FA7] underline decoration-dotted underline-offset-2 cursor-pointer">{result.student_name}</span>
                  </StudentSnapshot>
                  <div className="text-sm text-gray-500">
                    Grade {result.grade_level} • {new Date(result.scored_at).toLocaleDateString()}
                  </div>
                </div>
              </div>
              <div className={`wida-badge level-${result.wida_level}`}>
                <span className="font-bold mr-1">{result.wida_level}</span>
                <span className="text-sm">{result.wida_level_name}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentResultsTab;
